@if (!areAllFieldsHidden) {
  @if ({ isEditing: isEditing$ | async, selectedRow: selectedRow$ | async }; as data) {
    @if (props.label) {
      <apm-section-title
        [title]="props.label | apmTranslate"
        [ngClass]="{ 'mt-5': !isFirst }"
        matTooltip="{{ hasDatasheetMoreDetailsPermission ? field.key : '' }}"
      ></apm-section-title>
    }

    @for (row of field.fieldGroup; track $index) {
      <apm-list-tile
        [ngClass]="{
          'w-100': true,
          'bg-selected-row': data.selectedRow === row.key,
          'bg-editable-row': props.editable && data.isEditing,
          'bg-certified-row--green': row.props?.flags === 1,
          'bg-certified-row--light-green': row.props?.flags === 3,
          'bg-certified-row--orange': row.props?.flags === 4,
        }"
        [isButton]="true"
        (listTileClick)="setSelectedRow(row.key)"
        matTooltip="{{ hasDatasheetMoreDetailsPermission ? row.key : '' }}"
      >
        @let iconResourceId = row.props?.iconResourceId;
        @if (iconResourceId) {
          <img class="pe-1" [apmResourceImage]="iconResourceId" height="24" />
        }
        @if (row.props?.label) {
          <span class="text bold flex-grow-1 me-2">{{ getRowLabel(row.props) }}</span>
        }
        <div class="text-end"><formly-field [field]="row"></formly-field></div>
      </apm-list-tile>
    }
    @if (props.image) {
      <div class="d-flex justify-content-center mt-3">
        <img src="{{ props.image }}" />
      </div>
    }
  }
}
